export enum SupportPriority {
  Urgent = 'Urgent',
  High = 'High',
  Medium = 'Medium',
  Low = 'Low',
}

export interface SupportPayload {
  ticketEmail: string
  ticketMessage: string
  ticketTypeId: string
  priority: SupportPriority
}
